import React from "react";
import { UserIcon, BriefcaseIcon } from "@heroicons/react/solid";
import InfoCard from "./InfoCard";
import {
  faHourglassEnd,
  faClock,
  faCheckCircle,
  faPlane,
} from "@fortawesome/fontawesome-free-solid";
import LoadingIcon from "../loading/LoadingIcon";
import { useSelector } from "react-redux";

// import MercedesCar from "../../assets/mercedes.png";

const VehiclePriceCard = ({
  b2b,
  vehicleName,
  passengers,
  luggages,
  description,
  image,
  price,
  unit,
  onClick,
  isOffLine = false,
  priceInputChange,
  priceValue,
}) => {
  const { token, user } = useSelector((state) => state.auth);
  const { selectdCurrency, currencyprice, bookingInitiateLoading } =
    useSelector((state) => state.booking);

  return (
    <div className="lg:flex grow justify-between mx-3 md:mx-5 xl:mx-6 border rounded-md shadow-md hover:shadow-lg border-gray-30 md:w-[90%] lg:w-[90%]">
      <div className="sm:w-full lg:w-auto">
        <div className="flex items-center px-4 pt-4 space-x-6">
          {/* vehicle name */}
          <div className="flex space-x-2 items-center">
            <div
              className={`${
                b2b ? "text-xs sm:text-lg lg:text-2xl" : "text-lg lg:text-2xl"
              }   font-semibold font-sans text-black`}
            >
              {vehicleName.split("|")[0]}
            </div>
            <div
              className={`${
                b2b ? "text-[1rem] sm:text-lg text-lg lg:text-2xl" : "text-lg lg:text-2xl"
              }   font-semibold font-sans text-slate-400 italic`}
            >
              {vehicleName.split("|")[1]}
            </div>
          </div>
          <div className="flex space-x-2">
            {/*  person */}
            <div className="flex items-center space-x-1 ">
              {" "}
              <UserIcon className="w-5 h-5 text-gray-600" />{" "}
              <div className="text-sm">{passengers} Max</div>
            </div>
            {/* luggage */}
            <div className="flex items-center space-x-2">
              {" "}
              <BriefcaseIcon className="w-5 h-5 text-gray-600" />{" "}
              <div className="text-sm">{luggages} Max</div>
            </div>
          </div>
        </div>
        <div className="px-4 text-sm font-normal text-secondary">
          {description}
        </div>
        <div className="px-4 pt-4 mb-3 lg:w-full text-base">
          <InfoCard
            b2b={b2b}
            color="text-orange-700"
            fontawesomeIconName={faCheckCircle}
            infotext="Free 60 minutes waiting time after flight landing for airport pickups, 15 minutes waiting time for all other pickups."
          />

          <InfoCard
            b2b={b2b}
            color="text-yellow-700"
            fontawesomeIconName={faCheckCircle}
            infotext="Free cancellation upto 24 hour prior to time for both oneway transfer and hourly disposals."
          />
          <InfoCard
            b2b={b2b}
            color="text-green-600"
            fontawesomeIconName={faCheckCircle}
            infotext="Flight No./Train No. is mandatory for airport/station pickup and dropoff."
          />
          <InfoCard
            b2b={b2b}
            color="text-green-600"
            fontawesomeIconName={faCheckCircle}
            infotext="Guest/luggage capacities must be abided by for safety reasons. If you are unsure, select a larger class as chauffeurs may turn 
            down service when they are exceeded."
          />
          <InfoCard
            b2b={b2b}
            color="text-green-600"
            fontawesomeIconName={faCheckCircle}
            infotext="The vehicle images are just for reference, you may get a different vehicle of similar quality depending on destination."
          />
          <InfoCard
            b2b={b2b}
            color="text-green-600"
            fontawesomeIconName={faCheckCircle}
            infotext="All prices include VAT, Gratuities, Meet and Greet services. "
          />
        </div>
      </div>
      <div className="xl:-mt-10 my-10">
        {/* car picture */}
        <div
          className={`${
            b2b
              ? "transform -translate-y-12 translate-x-4 sm:mt-10"
              : "transform -translate-y-6 translate-x-4 flex justify-center lg:flex-none"
          } `}
        >
          <img
            src={image}
            alt="car"
            className={
              b2b
                ? "w-72 lg:w-64 xl:w-72 h-full lg:bg-auto center"
                : "w-64 h-full transform"
            }
          />
        </div>
        <div
          className={
            b2b ? "sm:-translate-y-5 lg:translate-y-0" : "-translate-y-2 mt-3"
          }
        >
          {!isOffLine ? (
            <div className="flex items-center justify-center md:justify-center lg:justify-start xl:justify-start space-x-2 transform lg:translate-x-1/3">
              <span className="text-xl font-semibold text-secondary">
                {unit}
              </span>

              <span
                className={`${
                  b2b ? "text-2xl" : "text-4xl"
                }   text-primary font-semibold`}
              >
                {price === "Loading..." ? <LoadingIcon /> : price}
              </span>
            </div>
          ) : (
            <>
              <div className="flex items-center space-x-2 text-center ml-24">
                <div className="text-xl font-bold text-secondary">
                  {selectdCurrency}
                </div>
                <input
                  type="text"
                  placeholder="Add Price"
                  onChange={priceInputChange}
                  value={priceValue}
                  className=" text-xl font-bold w-28 text-primary"
                />
              </div>
            </>
          )}
          {user.permission?.newBooking?.MakeBooking?.permission ===
          "DISABLE" ? (
            <div>
              <div className="w-64 animate-pulse text-white bg-secondary px-3 py-2 rounded-md ">
                You don't have permission to make a booking
              </div>
            </div>
          ) : (
            <>
              {!bookingInitiateLoading ? (
                <div
                  onClick={onClick}
                  className={`bg-secondary hover:bg-gray-300 hover:text-black font-semibold cursor-pointer text-white ${
                    b2b ? "font-regular" : "font-semibold"
                  }  text-center py-1.5 md:px-5 ${
                    b2b ? "mx-5" : "mx-3"
                  }  rounded-md`}
                >
                  BOOK NOW
                </div>
              ) : (
                <div
                  className={`bg-secondary hover:bg-gray-300 hover:text-black font-semibold cursor-pointer text-white ${
                    b2b ? "font-regular" : "font-semibold"
                  }  text-center py-3 md:px-5 ${
                    b2b ? "mx-5" : "mx-3"
                  }  rounded-md`}
                >
                  <div className="flex space-x-2 items-center justify-center">
                    {/* <div className="font-thin">Loading...</div> */}
                    <LoadingIcon />
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        {/* price with button */}
      </div>
    </div>
  );
};

export default VehiclePriceCard;
